import React, { useState } from 'react';
import { TableBody, TableContainer, TextField, MenuItem } from '@mui/material';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable';
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader';
import muiInputStyles from '../../../uiComponents/MuiInput/MuiInputStyles';
import { stableSort, getComparator, handleRequestSort } from '../../../uiComponents/MuiTable/MuiHelper.js';
import AnalyteGroup from '../../../config/AnalyteGroup';
import { instrumentOptions, reagentKitOptions } from '../../../config/BiochemicalInstrumentation.js';

const headCells = [
  { label: 'Analyte Group', id: 'AnalyteGroup', numeric: false, disablePadding: false },
  { label: 'Instrument', id: 'Instrument', numeric: false, disablePadding: false, type: 'noSort' },
  { label: 'Reagent Kit', id: 'ReagentKit', numeric: false, disablePadding: false, type: 'noSort' },
  { label: 'Lot Number', id: 'LotNumber', numeric: false, disablePadding: false, type: 'noSort' },
];

export default function ProgramSettingsBiochemicalTable({ data, selectedValues, handleTableSelectionChange }) {
    const classes = muiInputStyles();
    const [order, setOrder] = useState('asc'); //default sort direction
    const [orderBy, setOrderBy] = useState('AnalyteGroup'); //default sort column for table

    const handleChange = (analyteGroup, field, value) => {
        handleTableSelectionChange(analyteGroup, { [field]: value });
    };

    return (
        <StyledPaper>
        <TableContainer>
            <StyledTable size="small" aria-label="Biochemical Instrumentation Settings">
                <MuiTableHeader 
                    headCells={headCells}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={(event, property) => handleRequestSort(event, property, order, orderBy, setOrder, setOrderBy)}
                />
                <TableBody>
                    {data && data.length ? (
                    stableSort(data, getComparator(order, orderBy))
                    .map((row, index) => {
                        const rowValues = selectedValues?.[row.AnalyteGroup] || {};
                        return (
                        <StyledTableRow key={row.AnalyteGroup || index}>
                            <StyledTableCell style={{ width: '25%' }}>
                                {AnalyteGroup[row.AnalyteGroup] || row.AnalyteGroup}
                            </StyledTableCell>
                            <StyledTableCell style={{ width: '25%' }}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                className={classes.muiInputs}
                                label="Instrument"
                                value={rowValues.Instrument ?? row.Instrument ?? ""}
                                onChange={e => handleChange(row.AnalyteGroup, 'Instrument', e.target.value)}
                                variant="outlined"
                                SelectProps={{
                                MenuProps: { disableScrollLock: true, disablePortal: true, }
                                }}
                            >
                                {instrumentOptions.map(opt => (
                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                ))}
                            </TextField>
                            </StyledTableCell>
                            <StyledTableCell style={{ width: '25%' }}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                className={classes.muiInputs}
                                label="Reagent Kit"
                                value={rowValues.ReagentKit ?? row.ReagentKit ?? ""}
                                onChange={e => handleChange(row.AnalyteGroup, 'ReagentKit', e.target.value)}
                                variant="outlined"
                                SelectProps={{
                                MenuProps: { disableScrollLock: true, disablePortal: true,}
                                }}
                            >
                                {reagentKitOptions.map(opt => (
                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                ))}
                            </TextField>
                            </StyledTableCell>
                            <StyledTableCell style={{ width: '25%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                className={classes.muiInputs}
                                label="Lot Number"
                                value={rowValues.LotNumber ?? row.LotNumber ?? ""}
                                onChange={e => handleChange(row.AnalyteGroup, 'LotNumber', e.target.value)}
                                variant="outlined"
                            />
                            </StyledTableCell>
                        </StyledTableRow>
                        );
                    })
                    ) : (
                    <StyledTableRow>
                        <StyledTableCell colSpan={4} style={{ textAlign: 'center' }}>
                        No biochemical instrumentation settings found
                        </StyledTableCell>
                    </StyledTableRow>
                    )}
                </TableBody>
            </StyledTable>
        </TableContainer>
        </StyledPaper>
    );
}